import { render, staticRenderFns } from "./MarketingTask.vue?vue&type=template&id=17f83c9a&scoped=true"
import script from "./MarketingTask.vue?vue&type=script&lang=js"
export * from "./MarketingTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f83c9a",
  null
  
)

export default component.exports